module.exports = __webpack_public_path__ + "img/chris_g_31.a85ceb63.jpg";